/**
 * What a row of the items grid costs, and what an empty row looks like.
 *
 * Shared by order entry and order editing so the amount a grid shows is worked
 * out the same way on both — the backend derives it again from the same rule.
 */

export const BLANK_ITEM = {
  item_name: '',
  quantity: '',
  // most work is quoted per piece, so that is the rate the grid opens on
  price_type: 'per_piece',
  item_value: '',
  price_per_piece: '',
  price_per_sheet: '',
  pieces_per_sheet: '',
  expected_delivery_date: '',
  special_instructions: '',
  catalog_item_id: null,
  catalog_price_source: null,
  // what is free on the shelf for this product, and what the desk decided to do
  // about it: send it from there, or run the job longer than the order
  catalog_stock: 0,
  fulfill_from_stock: false,
  surplus_quantity: '',
};

export const RATE_FIELD = {
  per_piece: 'price_per_piece',
  per_sheet: 'price_per_sheet',
  total: 'item_value',
};

export const RATE_UNITS = [
  ['per_piece', '/pc'],
  ['total', 'lump'],
  ['per_sheet', '/sht'],
];

export function calcItemTotal(item) {
  const qty = parseInt(item.quantity || 0) || 0;
  if (item.price_type === 'per_piece' && item.price_per_piece) {
    return parseFloat(item.price_per_piece) * qty;
  }
  if (item.price_type === 'per_sheet' && item.price_per_sheet && item.pieces_per_sheet) {
    return Math.ceil(qty / parseInt(item.pieces_per_sheet)) * parseFloat(item.price_per_sheet);
  }
  return parseFloat(item.item_value) || 0;
}

/** Discount then GST, in that order, off the items total. */
export function orderTotals(itemsTotal, orderDetails) {
  const discount = itemsTotal * (parseFloat(orderDetails.discount_pct) || 0) / 100;
  const taxable = itemsTotal - discount;
  const gst = taxable * (parseFloat(orderDetails.gst_pct) || 0) / 100;
  const advance = parseFloat(orderDetails.advance_payment) || 0;
  return { discount, taxable, gst, total: taxable + gst, advance };
}
